var map = {
	"./bagging.svg": 842965,
	"./bagging_protection.svg": 200369,
	"./box_building.svg": 986163,
	"./bubble_mailer.svg": 486998,
	"./bubble_wrapping.svg": 725093,
	"./damage_protection.svg": 966971,
	"./kitting.svg": 48273,
	"./kitting_prep_logo.svg": 805401,
	"./sku_labels.svg": 329821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50688;